// removed by extract-text-webpack-plugin
module.exports = {"btn":"Button-m__btn___3YHna","btnWrapper":"Button-m__btnWrapper___30axC","btnSmall":"Button-m__btnSmall___gSe9s","btnIconed":"Button-m__btnIconed___1-sLM","btnExtraSmall":"Button-m__btnExtraSmall___CsNJq","btnIcon":"Button-m__btnIcon___2F9BN","btnIconRight":"Button-m__btnIconRight___t36Xt","btnIconLeft":"Button-m__btnIconLeft___--JCY","full":"Button-m__full___w-l9O","gradient":"Button-m__gradient___2ofph","big":"Button-m__big___1FoOq","price":"Button-m__price___39d1r"};


//////////////////
// WEBPACK FOOTER
// ./components/button/Button.m.sass
// module id = qPBs
// module chunks = 0